// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-layouts-md-page-js": () => import("/opt/build/repo/src/layouts/md-page.js" /* webpackChunkName: "component---src-layouts-md-page-js" */),
  "component---src-pages-404-js": () => import("/opt/build/repo/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-faerun-js": () => import("/opt/build/repo/src/pages/faerun.js" /* webpackChunkName: "component---src-pages-faerun-js" */),
  "component---src-pages-index-js": () => import("/opt/build/repo/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

